import React from 'react';
import { CalendarPlus, Download, ChevronDown } from 'lucide-react';
import { Button } from '../ui/button';
import {
  DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuLabel, DropdownMenuSeparator, DropdownMenuTrigger,
} from '../ui/dropdown-menu';
import { fileUrl } from '../../lib/api';

// "Add to calendar" for one event. The .ics file opens straight in the
// phone's calendar app (Apple Calendar, Samsung, Outlook app); Google and
// Outlook.com get direct compose links. Hidden for cancelled events.
export const AddToCalendar = ({ ev, size = 'sm', variant = 'outline', className = '', testId = 'event-add-to-calendar' }) => {
  const cal = ev?.calendar;
  if (!cal || !cal.ics_url || ev.cancelled) return null;
  const icsHref = fileUrl(cal.ics_url);
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button size={size} variant={variant} className={`h-9 border-[#1a2744] text-[#1a2744] font-bold btn-press bg-white ${className}`} data-testid={testId} aria-label={`Add ${ev.title} to your calendar`}>
          <CalendarPlus className="h-3.5 w-3.5 mr-1.5" /> Add to calendar <ChevronDown className="h-3.5 w-3.5 ml-1 opacity-70" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="start" className="w-64 bg-white shadow-lg border-slate-200" data-testid={`${testId}-menu`}>
        <DropdownMenuLabel className="text-xs text-slate-500 font-semibold">Save this event to your phone or computer</DropdownMenuLabel>
        <DropdownMenuSeparator />
        <DropdownMenuItem asChild>
          <a href={icsHref} download className="cursor-pointer" data-testid={`${testId}-ics`}>
            <Download className="h-4 w-4 mr-2 text-[#24406f]" /> Apple, Samsung or Outlook app (.ics)
          </a>
        </DropdownMenuItem>
        <DropdownMenuItem asChild>
          <a href={cal.google_url} target="_blank" rel="noreferrer" className="cursor-pointer" data-testid={`${testId}-google`}>
            <CalendarPlus className="h-4 w-4 mr-2 text-[#24406f]" /> Google Calendar
          </a>
        </DropdownMenuItem>
        <DropdownMenuItem asChild>
          <a href={cal.outlook_url} target="_blank" rel="noreferrer" className="cursor-pointer" data-testid={`${testId}-outlook`}>
            <CalendarPlus className="h-4 w-4 mr-2 text-[#24406f]" /> Outlook.com
          </a>
        </DropdownMenuItem>
        {cal.all_day && (
          <>
            <DropdownMenuSeparator />
            <p className="px-2 py-1.5 text-xs text-slate-500">Start time not announced yet, so this saves as an all-day reminder.</p>
          </>
        )}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
